import { buildFacetManager, buildFacet, Facet, FacetManager, SearchEngine } from '@coveo/headless';
import sitesHeadlessEngine from './sitesHeadlessEngine';
export interface SitesHeadlessFacets {
  facetManager: FacetManager;
  siteStateFacet: Facet;
  siteStateCodeFacet: Facet;
  siteRelatedConditionsFacet: Facet;
  siteRelatedCommunitiesFacet: Facet;
  siteLanguagesFacet: Facet;
  siteStatusFacet: Facet;
  siteRecruitingTypeFacet: Facet;
  sitePhaseFacet: Facet;
}
const DEFAULT_RESULTS_PER_PAGE = parseInt(
  process.env.NEXT_PUBLIC_DEFAULT_RESULTS_PER_PAGE || '100000'
);
export const buildSitesHeadlessFacets = (
  // eslint-disable-next-line @typescript-eslint/ban-types
  engine: SearchEngine<{}>
): SitesHeadlessFacets => ({
  facetManager: buildFacetManager(engine),
  siteStateFacet: buildFacet(engine, {
    options: { field: 'site_state', numberOfValues: DEFAULT_RESULTS_PER_PAGE },
  }),
  siteStateCodeFacet: buildFacet(engine, {
    options: { field: 'site_statecode', numberOfValues: DEFAULT_RESULTS_PER_PAGE },
  }),
  siteRelatedConditionsFacet: buildFacet(engine, {
    options: { field: 'site_relatedconditions', numberOfValues: DEFAULT_RESULTS_PER_PAGE },
  }),
  siteRelatedCommunitiesFacet: buildFacet(engine, {
    options: { field: 'site_relatedcommunities', numberOfValues: DEFAULT_RESULTS_PER_PAGE },
  }),
  siteLanguagesFacet: buildFacet(engine, {
    options: { field: 'site_languages', numberOfValues: DEFAULT_RESULTS_PER_PAGE },
  }),
  siteStatusFacet: buildFacet(engine, {
    options: { field: 'site_status', numberOfValues: DEFAULT_RESULTS_PER_PAGE },
  }),
  siteRecruitingTypeFacet: buildFacet(engine, {
    options: { field: 'site_recruitingtype', numberOfValues: DEFAULT_RESULTS_PER_PAGE },
  }),
  sitePhaseFacet: buildFacet(engine, {
    options: { field: 'site_phase', numberOfValues: DEFAULT_RESULTS_PER_PAGE },
  }),
});

let cachedFacets: SitesHeadlessFacets | null = null;

/** Lazily builds and caches facets for the default sites engine. Client-side only. */
export const getSitesHeadlessFacets = (): SitesHeadlessFacets => {
  if (typeof window === 'undefined') {
    throw new Error('Sites headless facets must be initialized on the client');
  }

  if (!cachedFacets) {
    cachedFacets = buildSitesHeadlessFacets(sitesHeadlessEngine);
  }

  return cachedFacets;
};
